<template>
  <div id="app" >
    <div v-bind:style="{minHeight: Height + 'px'}">
      <div id="nav">
        <router-link to="/notice">注意力训练</router-link> |
        <router-link to="/calc">计算训练</router-link> |
        <router-link to="/">登录</router-link> |
      </div>
      <router-view/>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import vFooter from './components/vFooter'
export default {
  name: 'App',
  data(){
    return {
      Height: 0
    }
  },
  components: {
    vFooter
  },
  mounted() {
    this.Height = document.documentElement.clientHeight - 40;
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -40}
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
#nav {
  padding: 20px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
